export default __webpack_public_path__ + "images/0a12848732515ac4392827219a9683b5-holiday.webp";